import React from "react";

export const ScanlineOverlay = () => (
  <div className="pointer-events-none absolute inset-0 scanline-overlay z-[5]" aria-hidden="true" />
);

export default ScanlineOverlay;
